const cache = new Map();

const makeTranslationsBaseUrl = (useMock = false) => {
  if (process.env.NEXT_PUBLIC_USE_TRANSLATION_MOCK_API) {
    console.log('USING TRANSLATION MOCK API');
    useMock = true; // eslint-disable-line no-param-reassign
  }

  if (typeof window !== 'undefined') {
    return useMock ? '/mock-api/api' : '/mt-api';
  }

  return useMock ? `${process.env.URL_MOCK_INTERNAL}/api` : process.env.URL_API_INTERNAL;
};

const makeTranslationsUrl = (url, useMock = false) => {
  const baseUrl = makeTranslationsBaseUrl(useMock);
  const effectiveUrl = `${baseUrl}${url}`;

  return effectiveUrl;
};

async function fetchTranslations(url) {
  if (cache.has(url)) {
    return cache.get(url);
  }

  const response = await fetch(url);
  const translationData = await response.json();

  cache.set(url, translationData);
  return translationData;
}

async function getTranslations({ namespace, locale, useMock = false }) {
  const translationsUrl = makeTranslationsUrl(`/translations/${locale}/${namespace}`.toLowerCase(), useMock);
  return fetchTranslations(translationsUrl);
}

module.exports = {
  loader: false,
  logBuild: false,
  keySeparator: ':',
  locales: ['nl-NL'],
  defaultLocale: 'nl-NL',
  extensionsRgx: /\.page\.(tsx|ts|js|mjs|jsx)$/,
  pages: {
    '*': ['header', 'footer', 'common', 'form-errors', 'login', 'product-details', 'search'],
    'rgx:^/mijn-carel-lurvink': ['tabbed-layout'],
    'rgx:^/mijn-carel-lurvink/catalogus': ['catalog', 'product-details'],
    'rgx:^/mijn-carel-lurvink/beheer/afleveradressen': ['delivery-addresses'],
    'rgx:^/mijn-carel-lurvink/beheer/bestellijsten': ['orderlists'],
    'rgx:^/mijn-carel-lurvink/beheer/medewerkers': ['employees'],
    'rgx:^/mijn-carel-lurvink/beheer/mijn-account': ['my-account'],
    'rgx:^/mijn-carel-lurvink/bestelgeschiedenis': ['orderhistory', 'invoices', 'shipments', 'returns'],
    'rgx:^/mijn-carel-lurvink/dashboard': ['dashboard'],
    'rgx:^/wachtwoord-vergeten': ['forgot-password'],
    'rgx:^/wachtwoord-reset': ['reset-password'],
    'rgx:^/catalogus': ['catalog'],
    'rgx:^/registreren': ['register', 'password-strength'],
    'rgx:^/redux-examples': ['example'],
    'rgx:^/winkelwagen': ['shopping-cart'],
    'rgx:^/afrekenen': ['checkout', 'register', 'form-errors', 'password-strength', 'shopping-cart'],
    'rgx:^/blog': ['blog']
  },
  loadLocaleFrom: (locale, namespace) => {
    const translationData = getTranslations({ namespace, locale, useMock: true });
    return translationData;
  },
  logger: async (translation) => {
    const { namespace, i18nKey } = translation;
    if (process.env.NEXT_PUBLIC_SAVE_MISSING_TRANSLATIONS) {
      try {
        const translationsUrl = '/clapi/i18n/translations';
        const res = await fetch(translationsUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            namespace,
            key: i18nKey
          })
        });

        if (!res.ok) {
          throw new Error(`Save missing translation failed: ${res.status}`);
        }

        console.log(`Save missing translation succeeded: ${namespace}:${i18nKey}`);
      } catch (e) {
        console.error(`Save missing translation failed: ${namespace}:${i18nKey} '\n' Reason: ${e}`);
      }
    }
  }
};
